import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import MemberResources from "./components/MemberResources";
import PaidUnlock from "./components/PaidUnlock";
import Collections from "./components/Collections";
import Discussion from "./components/Discussion";
import MemberCta from "./components/MemberCta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <TopNav />
      <Hero />
      <HotBoard />
      <MemberResources />
      <PaidUnlock />
      <Collections />
      <Discussion />
      <MemberCta />
      <Footer />
    </main>
  );
}